import React from "react";
import { Bell, Check, Send, Lock, Info } from "lucide-react";

function fmtShort(value) {
  return value
    ? new Date(value).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" })
    : "";
}

function SuiviCell({ etape, onNotify, onCloture, onShowDetails }) {
  if (etape.statut === "CLOTURE") {
    const closerInitials = etape.closedBy
      ? `${etape.closedBy.name?.[0] || ""}${etape.closedBy.lastName?.[0] || ""}`.toUpperCase()
      : "";
    const enRetard = etape.clotureATemps === false;
    return (
      <div
        className="pc-closed-box"
        title={`Clôturé${
          etape.closedBy ? ` par ${etape.closedBy.name} ${etape.closedBy.lastName || ""}` : ""
        }${etape.closedAt ? ` le ${new Date(etape.closedAt).toLocaleDateString("fr-FR")}` : ""}`}
      >
        <span className="pc-closed">
          <Check size={12} /> Clôturé
        </span>
        <div className="pc-closed-meta">
          {closerInitials && <span className="pc-closed-by">{closerInitials}</span>}
          <span className="pc-closed-date">{fmtShort(etape.closedAt)}</span>
          {etape.delaiJours !== null && etape.delaiJours !== undefined && (
            <span
              className={`pc-jplus ${enRetard ? "is-late" : ""}`}
              title={`${etape.delaiJours} jour${etape.delaiJours > 1 ? "s" : ""} de traitement — ${
                enRetard ? "clôturé après échéance" : "clôturé dans les délais"
              }`}
            >
              J+{etape.delaiJours}
            </span>
          )}
          <button
            type="button"
            onClick={() => onShowDetails(etape)}
            title="Voir le détail de la clôture"
            className="pc-act-btn pc-details-btn"
          >
            <Info size={12} />
          </button>
        </div>
      </div>
    );
  }

  const locked = etape.statut === "VERROUILLE";
  // Comme dans la maquette : notifier et clôturer nécessitent un collaborateur
  // affecté sur l'étape.
  const peutNotifier = !locked && !!etape.assignee;
  const peutCloturer = !locked && !!etape.assignee;
  // Étape déjà notifiée (cloche ou clôture d'une étape précédente avec
  // "Personne à notifier") — bouton en vert pour le signaler d'un coup d'œil.
  const dejaNotifie = (etape.notifiedUsers?.length || 0) > 0;

  return (
    <div className="pc-actions">
      {/* Étape 3 uniquement : "Créer une demande" (futur lien MyALFA Link) et
          la clôture mensuelle — placeholders non fonctionnels pour l'instant,
          hors périmètre de cette itération. */}
      {etape.niveau === 3 && (
        <>
          <button
            type="button"
            disabled
            title="Créer une demande (à venir — lien MyALFA Link)"
            className="pc-act-btn pc-demande-btn"
          >
            <Send size={13} />
          </button>
          <button
            type="button"
            disabled
            title="Créer une clôture mensuelle (à venir)"
            className="pc-act-btn pc-cloture-btn"
          >
            <Lock size={13} />
          </button>
        </>
      )}
      <button
        type="button"
        disabled={!peutNotifier}
        onClick={() => onNotify(etape)}
        title={
          dejaNotifie
            ? "Notifier le collaborateur (déjà notifié)"
            : "Notifier le collaborateur"
        }
        className={`pc-act-btn ${dejaNotifie ? "is-notified" : ""}`}
      >
        <Bell size={13} />
      </button>
      <button
        type="button"
        disabled={!peutCloturer}
        onClick={() => onCloture(etape)}
        title="Clôturer le ticket"
        className="pc-act-btn pc-close-btn"
      >
        <Check size={13} />
      </button>
    </div>
  );
}

export default SuiviCell;
